export const ADMIN_TOKEN_KEY = "grawish_admin_token";
export const ADMIN_USER_KEY = "grawish_admin_user";

export const saveAdminSession = ({ token, admin }) => {
  window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
  window.localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(admin));
};

export const clearAdminSession = () => {
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
  window.localStorage.removeItem(ADMIN_USER_KEY);
};

export const getStoredAdmin = () => {
  const rawAdmin = window.localStorage.getItem(ADMIN_USER_KEY);
  if (!rawAdmin) {
    return null;
  }

  try {
    return JSON.parse(rawAdmin);
  } catch (_error) {
    return null;
  }
};

export const hasAdminSession = () => Boolean(window.localStorage.getItem(ADMIN_TOKEN_KEY));
